// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 35 ? "player" : chunkId) + "." + {"35":"92d71230","444":"d2e8ca76","630":"d378a95d"}[chunkId] + ".chunk.js";
};